import PayNetFooter from "../../../../shared/PayNetFooter"

export default function Footer() {
  return (
    <div className="flex flex-col items-center justify-center py-6">
      <PayNetFooter />
      <div className="mt-6 flex gap-8 text-sm text-gray-500">
        <div className="footer-item">
          <a
            href="https://aye-ai.org/privacy-legal/"
            className="underline">
            PRIVACY POLICY
          </a>
        </div>
        <div className="footer-item">
          <a href="https://aye-ai.org/user-tc/" className="underline">
            LEGAL
          </a>
        </div>
        <div className="footer-item">
          <a
            href="https://api.whatsapp.com/send?phone=60162666192"
            className="underline">
            CONTACT US
          </a>
        </div>
      </div>
    </div>
  )
}
